import axios from '../external/Axios';
import Url from '../constants/Url';

class ParticipationApi {
    get(params) {
        return axios
            .get(Url().PARTICIPATION.GET_FORM, {params})
            .then(res => {
                return res.data.data;
            })
            .catch(ex => {
                console.info('Failed to get participation form:', ex.message);
                throw ex;
            });
    }

    save(data) {
        return axios
            .post(Url().PARTICIPATION.SAVE_FORM, data)
            .then(res => {
                return res.data.data;
            })
            .catch(ex => {
                console.info('Failed to save participation form:', ex.message);
                throw ex;
            });
    }
}

export default new ParticipationApi();
